import type { FaireThemeEntity } from "../../entity_types/theme";

export const pocket_sized_protection_under_10: FaireThemeEntity = {
  token: "pocket-sized-protection-under-10",
  type: "theme",
  name: "Pocket-Sized Protection under $10",
  description: "High-quality wellness solutions that won't break the bank -- perfect impulse buys for checkout.",
  teaser: "Under-$10 wellness impulse buys for your checkout table.",
  detail: "Aligns with your business model of ordering small-batch, artisanal products within a value-driven price point. Anchored at the $10 price point where Immunity Spray wholesales for $9.80.",
  bgColor: "#F5E6C8",
  exactProducts: true,
  retailerToken: "r_vywa5ks4ga",
  productTokens: [
    "p_vrp2jmxbp9",
    "p_mna0e5vjkz",
    "p_kzf4azpurn",
    "p_59a373mwjb",
    "p_81zhmnckey",
    "p_eunmj5rq9y",
    "p_vtk3bjumnj",
    "p_d4knxmza9r",
    "p_rcszdb9nmw",
    "p_btmeup7wpp",
    "p_2p98hr6ktw",
    "p_trk8jytxjt",
    "p_yb3hyfkh2k",
    "p_w5w6293588",
    "p_wpc83d8ss5",
    "p_x48qh3swd5",
    "p_5gay6r22jg",
    "p_mb7pz63w34",
    "p_enhx2t322u",
    "p_6ybt2frtty",
    "p_r77nhznxsh",
    "p_bpchyjzj4w",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00Z",
    importedBy: "manual-v2-import",
  },
};
